// extracted by mini-css-extract-plugin
export default {"followButton":"FS-z","followCount":"GS-z","textStyle":"HS-z"};